function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChartArrowUpi = function SvgChartArrowUpi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m20.83 5.151-6 9.426a.704.704 0 0 1-.95.225l-4.95-2.951-6.35 9.202a.707.707 0 0 1-.98.178.7.7 0 0 1-.18-.974l6.73-9.741a.694.694 0 0 1 .93-.203l4.93 2.939 5.56-8.725-1.86.632a.7.7 0 0 1-.89-.437.7.7 0 0 1 .44-.888l3.57-1.216a.693.693 0 0 1 .9.483l.95 3.54c.1.374-.13.757-.5.857s-.76-.123-.86-.497z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChartArrowUpi);
export default ForwardRef;